const lang = {
  dashboard: {
    extraction_condition: '抽出条件',
    tree_species_selection: '樹種選択',
    plan_number: '森林経営計画',
    forest_group: '林班',
    small_forest_group: '小班',
    small_forest_group_branch: '小班枝番',
    setting_default_text: '設定',
    setting_area_display: '設定エリア表示',
    setting_save: '保存',
    completed_button: 'クレジット化完了',
  },
  fo_information: {
    tree_species_ratio: '樹種比率',
    carbon_dioxide: '二酸化炭素',
    annual_absorption: '年間吸収量',
    t_co2: 't-CO2/年',
    forest_information: {
      table_title: '森林情報',
      forest_age: '樹齢',
      tree_height: '樹高',
      breast_height_diameter: '胸高直径',
      position: '地位',
      accumulation: '材積量',
      growth_rate: '成長率',
      tree_volume_increment: '材積成長量',
    },
    operation_history: {
      table_title: '施業履歴',
      operation_year: '施業年',
      operation_type: '施業種類',
      operation_area: '施業面積',
    },
  },
}

export default lang
